import React from 'react';
import { LayoutNodeStyle } from 'app/shop-ui/types';
import { HEADER_LAYOUT_TYPE } from '../define';

interface HeaderProps extends LayoutNodeStyle {
    type?: HEADER_LAYOUT_TYPE;
}

const Style1Header = (props) => {
    return (
        <div className="ssr-header ssr-header-layout-style-1" style={{ ...props }}>
            <div className="ssr-header-inner">
                <div className="ssr-header-logo skeleton skeleton--ssr" />
                <div className="ssr-header-searchbar skeleton skeleton--ssr" />
                <div className="ssr-header-spacer" />
                <div className="ssr-header-menu">
                    <div className="ssr-header-menu-item skeleton skeleton--ssr"></div>
                    <div className="ssr-header-menu-item skeleton skeleton--ssr"></div>
                    <div className="ssr-header-menu-item skeleton skeleton--ssr"></div>
                    <div className="ssr-header-menu-item skeleton skeleton--ssr"></div>
                </div>
                <div className="ssr-header-actions skeleton skeleton--ssr" />
            </div>
        </div>
    );
};

const Style2Header = (props) => {
    return (
        <div className="ssr-header ssr-header-layout-style-2" style={{ ...props }}>
            <div className="ssr-header-inner">
                <div className="ssr-header-menu">
                    <div className="ssr-header-menu-item skeleton skeleton--ssr"></div>
                    <div className="ssr-header-menu-item skeleton skeleton--ssr"></div>
                    <div className="ssr-header-menu-item skeleton skeleton--ssr"></div>
                    <div className="ssr-header-menu-item skeleton skeleton--ssr"></div>
                </div>
                <div className="ssr-header-spacer" />
                <div className="ssr-header-logo skeleton skeleton--ssr" />
                <div className="ssr-header-spacer" />
                <div className="ssr-header-searchbar skeleton skeleton--ssr" />
                <div
                    className="ssr-header-actions skeleton skeleton--ssr"
                    style={{ width: '5.01%' }}
                />
            </div>
        </div>
    );
};

const Style3Header = (props) => {
    return (
        <div className="ssr-header ssr-header-layout-style-3" style={{ ...props }}>
            <div className="ssr-header-inner">
                <div className="ssr-header-logo skeleton skeleton--ssr" />
                <div className="ssr-header-menu">
                    <div className="ssr-header-menu-item skeleton skeleton--ssr"></div>
                    <div className="ssr-header-menu-item skeleton skeleton--ssr"></div>
                    <div className="ssr-header-menu-item skeleton skeleton--ssr"></div>
                    <div className="ssr-header-menu-item skeleton skeleton--ssr"></div>
                </div>
                <div className="ssr-header-spacer" />
                <div className="ssr-header-searchbar skeleton skeleton--ssr" />
                <div className="ssr-header-actions skeleton skeleton--ssr" />
            </div>
        </div>
    );
};

const Style4Header = (props) => {
    return (
        <div className="ssr-header ssr-header-layout-style-4" style={{ ...props }}>
            <div className="ssr-header-inner">
                <div className="ssr-header-inner-item">
                    <div className="ssr-header-spacer" />
                    <div className="ssr-header-logo skeleton skeleton--ssr" />
                    <div className="ssr-header-searchbar skeleton skeleton--ssr" />
                    <div className="ssr-header-actions skeleton skeleton--ssr" />
                </div>
                <div className="ssr-header-inner-item">
                    <div className="ssr-header-menu">
                        <div className="ssr-header-menu-item skeleton skeleton--ssr"></div>
                        <div className="ssr-header-menu-item skeleton skeleton--ssr"></div>
                        <div className="ssr-header-menu-item skeleton skeleton--ssr"></div>
                        <div className="ssr-header-menu-item skeleton skeleton--ssr"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const headerTypeMap: Record<HEADER_LAYOUT_TYPE, React.FC<LayoutNodeStyle>> = {
    [HEADER_LAYOUT_TYPE.STYLE_1]: Style1Header,
    [HEADER_LAYOUT_TYPE.STYLE_2]: Style2Header,
    [HEADER_LAYOUT_TYPE.STYLE_3]: Style3Header,
    [HEADER_LAYOUT_TYPE.STYLE_4]: Style4Header,
};

export const Header: React.FC<HeaderProps> = (props) => {
    const { type, ...restProps } = props;

    const HeaderComponent = type ? headerTypeMap[type] : Style1Header;

    return <HeaderComponent {...restProps} />;
};
